export const SORT_BY_LAST_UPDATED = "SORT_BY_LAST_UPDATED";
export const SORT_BY_START_DATE = "SORT_BY_START_DATE";
export const SORT_BY_FINISH_DATE = "SORT_BY_FINISH_DATE";
export const SORT_BY_CREATION_DATE = "SORT_BY_CREATION_DATE";
